import {
  GoogleAnalyticsConnectorIcon,
  GoogleAnalyticsWhiteConnectorIcon,
} from '@/assets';
import { AccountSelection } from '../AccountSelection/AccountSelection';
import { GOOGLE_ANALYTICS_CONNECTION_STEPS } from '@/utils/constants';

export const GoogleAnalyticsEditAccounts = () => {
  return (
    <AccountSelection
      title="Google Analytics"
      connectionSteps={GOOGLE_ANALYTICS_CONNECTION_STEPS}
      selectedIcon={GoogleAnalyticsWhiteConnectorIcon}
      unselectedIcon={GoogleAnalyticsConnectorIcon}
    />
  );
};
